import React, {MouseEventHandler} from 'react'
import useId from 'modules/reports/hooks/id'
import UseTriggerContext from './useTrigger.context'

export type TriggerProps = {
  open: MouseEventHandler<any>
  id: string
  opened: boolean
  ariaProps: any
}

export type ContentProps = {
  id: string
  opened: boolean
  close: Function
  anchorEl: any
}

function useTrigger() {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const id = useId()
  const opened = Boolean(anchorEl)
  const ariaProps = {'aria-controls': id, 'aria-haspopup': 'true'}

  function open(event) {
    setAnchorEl(event.currentTarget)
  }

  function close() {
    setAnchorEl(null)
  }

  function renderTrigger(trigger: (props: TriggerProps) => React.ReactNode) {
    return trigger({open, id, opened, ariaProps})
  }

  function renderContent(content: (props: ContentProps) => React.ReactNode) {
    const contentProps = {id, opened, close, anchorEl}
    return (
      <UseTriggerContext.Provider value={{opened, close}}>
        {content(contentProps)}
      </UseTriggerContext.Provider>
    )
  }

  return {renderTrigger, renderContent}
}

export default useTrigger
